export default __webpack_public_path__ + "static/media/Red0005.cdd64a92.png";